import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "destroyOnClose": "",
      "data-sign": "compliance_officer_detail_modal",
      "width": 800,
      "title": _vm.t('商品GPSR信息详情')
    },
    on: {
      "cancel": _vm.handleClose
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-skeleton', {
    attrs: {
      "loading": _vm.loading
    }
  }, [!_vm.loading ? _c('a-form-model', {
    attrs: {
      "data-sign": "compliance_officer_detail_form",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u7F16\u7801:"),
      "label": _vm.t('商品编码:')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.product_sku)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u4E2D\u6587\u540D\u79F0:"),
      "label": _vm.t('商品中文名称:')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.product_name_cn)) + " ")]), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u82F1\u6587\u540D\u79F0:"),
      "label": _vm.t('商品英文名称:')
    }
  }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.product_name_en)) + " ")]), _vm._l(_vm.detailData.gpsr_dto_list, function (i) {
    return _c('div', {
      key: i.officer_no
    }, [_c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u5408\u89C4\u8D1F\u8D23\u4EBA\u7F16\u7801:"),
        "label": _vm.t('合规负责人编码:')
      }
    }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(i.officer_no)) + " ")]), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u5408\u89C4\u8D1F\u8D23\u4EBA\u7C7B\u578B:"),
        "label": _vm.t('合规负责人类型:')
      }
    }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(i.compliance_leader_type_text)) + " ")]), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u662F\u5426GPSR\u4EA7\u54C1:"),
        "label": _vm.t('是否GPSR产品:')
      }
    }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.detailData.is_gpsr_text)) + " ")]), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u72B6\u6001:"),
        "label": _vm.t('状态:')
      }
    }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(i.audit_status_text)) + " ")]), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u521B\u5EFA\u65F6\u95F4:"),
        "label": _vm.t('创建时间:')
      }
    }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.record.create_time)) + " ")]), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u66F4\u65B0\u65F6\u95F4:"),
        "label": _vm.t('更新时间:')
      }
    }, [_vm._v(" " + _vm._s(_vm._f("filterEmpty")(_vm.record.update_time)) + " ")]), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("GPSR\u6807\u7B7E\u6765\u6E90:"),
        "label": _vm.t('GPSR标签来源:')
      }
    }, [_vm._v(" " + _vm._s(i.label_source_text) + " ")]), i.label_source === _vm.$enum.product.GpsrLabelSourceEnum.GUCANG_DRAW ? [_c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("GPSR\u6807\u7B7E\u81EA\u5B9A\u4E49\u6A21\u677F:"),
        "label": _vm.t('GPSR标签自定义模板:')
      }
    }, [_vm._v($t("\u6A21\u677F\u5C3A\u5BF8\uFF1A100*150mm"))]), _c('div', {
      staticClass: "gd-label-wrap"
    }, [_c('ul', {
      staticClass: "ul-table"
    }, [_c('li', {
      staticClass: "row flex"
    }, [_c('p', [_vm._v("Product")]), _c('div', [_c('p', [_vm._v("Product name：" + _vm._s(i.gucang_draw_dto.product_name))]), _c('p', [_vm._v("Batch number：" + _vm._s(i.gucang_draw_dto.batch_number))]), _c('p', [_vm._v("Brand：" + _vm._s(i.gucang_draw_dto.brand))]), _c('p', [_vm._v("Made in: " + _vm._s(i.gucang_draw_dto.made_in))])])]), _c('li', {
      staticClass: "row flex"
    }, [_c('p', [_vm._v("Manufacturer")]), _c('div', [_c('p', [_vm._v("Name: " + _vm._s(_vm.officer_info.manufacturer_name))]), _c('p', [_vm._v("Address: " + _vm._s(_vm.officer_info.manufacturer_address))]), _c('p', [_vm._v("e-mail: " + _vm._s(_vm.officer_info.manufacturer_email))])])]), _vm.record.compliance_leader_type === _vm.$enum.product.COMPLIANCE_NAME_TYPE.IMPORTER ? _c('li', {
      staticClass: "row flex"
    }, [_c('p', [_vm._v("Importer")]), _c('div', [_c('p', [_vm._v("Name: " + _vm._s(_vm.officer_info.company))]), _c('p', [_vm._v("Address: " + _vm._s(_vm.officer_info.address))]), _c('p', [_vm._v("e-mail: " + _vm._s(_vm.officer_info.mail))])])]) : _vm._e(), _c('li', {
      staticClass: "row flex"
    }, [_c('p', {
      staticClass: "ec-rep"
    }, [_c('span', [_vm._v("EC")]), _c('span', [_vm._v("REP")])]), _c('div', [_c('p', [_vm._v("Name: " + _vm._s(_vm.officer_info.company))]), _c('p', [_vm._v("Address: " + _vm._s(_vm.officer_info.address))]), _c('p', [_vm._v("e-mail: " + _vm._s(_vm.officer_info.mail))])])]), _c('li', {
      staticClass: "row flex"
    }, [_c('p', [_vm._v("WARNING")]), _c('div', [_c('p', [_vm._v(_vm._s(i.gucang_draw_dto.warning))])])]), _c('li', {
      staticClass: "row flex"
    }, [_c('div', {
      ref: "warningLabelWrap",
      refInFor: true,
      staticClass: "flex warning-label-wrap"
    }, _vm._l(_vm.labelImageOptions, function (labelItem) {
      return _c('img', {
        key: labelItem.field_code,
        class: ['warning-label', {
          checked: i.gucang_draw_dto.warning_label_list.includes(labelItem.field_code)
        }],
        attrs: {
          "src": labelItem.field_name
        }
      });
    }), 0)])])])] : _vm._e(), i.label_source === _vm.$enum.product.GpsrLabelSourceEnum.CUSTOMER_UPLOAD ? _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("GPSR\u6807\u7B7E"),
        "label": _vm.t('GPSR标签')
      }
    }, [_c('attachment-list', {
      attrs: {
        "data": i.cust_file_list,
        "preview": true,
        "extendColumn": []
      }
    })], 1) : _vm._e(), _c('a-form-model-item', {
      attrs: {
        "fbu-analyse-name": $t("\u4EA7\u54C1\u6587\u4EF6"),
        "label": _vm.t('产品文件')
      }
    }, [i.file_list && i.file_list.length ? _c('attachment-list', {
      attrs: {
        "dataList": i.file_list,
        "data": i.file_list,
        "preview": true,
        "extendColumn": _vm.productExtendColumn
      }
    }) : _c('span', [_vm._v("--")])], 1)], 2);
  })], 2) : _vm._e()], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "transport_order_add_cancel",
      "id": "transport_order_add_cancel",
      "data-sign": "transport_order_cancel",
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t("关闭")))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };